import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";

// ------------------ COMPONENTES DE BASE--------------------------
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import Card from "../../../Base/Components/Card/Card";
import { toastShow } from "../../../Base/Services/ToastService";
import { getLabel } from "../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../Base/Context/ConfigContext/ConfigContext";
import { getDatesProduccion } from "../../../Base/Services/Moment/Luxon";
import { setTitlePage } from "../../../Base/Services/Config/ConfigService";
import AgGrid from "../../../Base/Components/Tables/AgGrid/AgGrid";
import CalendarioOperativo from "../../../Base/Components/Form/CalendarioOperativo";

// ------------------- CONSULTAS A LA API---------------------------
import { agregarConstruccionSalidas, agregarCuentaSalidas, EliminarSalidasMateriales, SalidasMDetalles, SalidasMP } from "../../../API/Suministros/SalidasMateriales/SalidasMaterialesRequest";
import { getConstruccionesConcatenadas } from "../../../API/Global/Construcciones/ConstruccionesRequest";
import { getCuentasHijosQuick } from "../../../API/Finanzas/RegistroContable/RegistroContableRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import IngresosBodegaCrud from "../../ERP/Suministros/Bodegas/IngresosBodega/IngresosCRUD/IngresosBodegaCrud";
import SalidasCRUD from "./SalidasCRUD";


const SalidasScreen = () => {

  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);

  const [listadoDet, setListadoDet] = useState([]);
  const [dates, setDates] = useState([new Date(), new Date()]);
  const [showDialogSalida, setShowDialogSalida] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);  
  const [ingresoToShow, setIngresoToShow] = useState(null);
  const [habilitar, setHabilitar] = useState(true);
  const [showDialogI, setShowDialogI] = useState(false);
  // El acceso 38 permite VER los costos de las salidas: se ocultan a quien no lo tiene
  const [hiddenCostosSalidas, setHiddenCostosSalidad] = useState(!userAuth.AccessWeb.split(",").map((e) => !parseInt(e)).includes(38));
  const [construcciones, setConstrucciones] = useState([]);
  const [cuentas, setCuentas] = useState([]);
  

  const getInfo = async () => {
    if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) {
      toastShow(toast, "warn", "Advertencia", "Por favor, seleccione un rango de fechas válido.");
      return;
    }
    setLoading(true);

    const construccionesTempo = await getConstruccionesConcatenadas()
    setConstrucciones(construccionesTempo)
    const cuentasTempo = await getCuentasHijosQuick()
    setCuentas(cuentasTempo)
    const fechas = getDatesProduccion(dates);
    const det = await SalidasMDetalles(fechas);
    setListadoDet(det)
    setSelected([])
    setLoading(false);
  };

  const eliminarSalida = async () => {
    if(selected.length === 0){
      toastShow( toast, "warn", "Advertencia", "Seleccione una salida de Material a Eliminar.");
      return;
    }else{
      selected.forEach(async (select) => {
        if (selected.length > 0) {
          const a = {
            IdSalidaDetalle: select?.IdSalidaDetalle,
            IdRequisaDet: select?.IdRequisaDetalle,
            IdProduct: select?.IdProducto,
            CantidadADespachar: select?.QtySalida,
            IdUsuarioDespacho: select?.IdUsuarioDespacho
          }

          const response = await EliminarSalidasMateriales(a)
          if (response[0].ESTADO !== -1) {
            toastShow(toast,"success","Eliminado",response[0].MENSAJE);
            getInfo()
          } else {
            toastShow(toast,"error","Error",response[0].MENSAJE);
          }

        } 
      })
    }
  };

  const TemplateConstruccion = ({ data, oldValue, api }, column) => {
    return (
      <Dropdown
        value={data?.IdSubConstruccion}
        options={construcciones}
        optionValue="IdSubConstruccion"
        optionLabel="NombreCompuesto"
        filter
        filterBy="NombreCompuesto"
        style={{ width: "100%" }}
        onChange={(e) => {
          let ConstruccionSeleccionda = construcciones.filter(i => i?.IdSubConstruccion === e?.value);
          let changes = [];
          let mensaje = "";

          if (selected.length > 0) {
            // Validar si alguno ya está revisado
            const revisados = selected.filter(item => item?.IdEstadoFinanzas === 112);
            if (revisados.length > 0) {
              toastShow(toast, 'error', 'Error', 'Una o más salidas ya están revisadas, no puede eliminar la construcción.');
              return; // detener el flujo
            }

            changes = selected.map((item) => {
              return {
                IdSalidaDetalle: item.IdSalidaDetalle,
                IdConstruccion: ConstruccionSeleccionda[0]?.IdConstruccion,
                IdSubConstruccion: ConstruccionSeleccionda[0]?.IdSubConstruccion,
                NombreCompuesto: ConstruccionSeleccionda[0]?.NombreCompuesto,
                IdEstadoFinanzas: item?.IdEstadoFinanzas,
              };
            });
          } else {
            if (data?.IdEstadoFinanzas === 112) {
              toastShow(toast, 'error', 'Error', 'La salida ya está revisada, no puede eliminar la construcción.');
              return; // detener el flujo
            }

            changes.push({
              IdSalidaDetalle: data.IdSalidaDetalle,
              IdConstruccion: ConstruccionSeleccionda[0]?.IdConstruccion,
              IdSubConstruccion: ConstruccionSeleccionda[0]?.IdSubConstruccion,
              NombreCompuesto: ConstruccionSeleccionda[0]?.NombreCompuesto,
              IdEstadoFinanzas: data?.IdEstadoFinanzas,
            });
          }

          // Mensaje de confirmación
          if (!ConstruccionSeleccionda[0]) {
            mensaje = `¿Está seguro de eliminar la construcción a ${changes.length} salidas?`;
          } else {
            mensaje = <>¿Agregar construcción <strong>{ConstruccionSeleccionda[0]?.NombreCompuesto}</strong> a {changes.length} salidas?</>;
          }

          confirmDialog({
            message: mensaje,
            header: "Confirmación",
            icon: "pi pi-exclamation-triangle",
            accept: async () => {
              let IdSalidaDetalles = changes.map((item) => item.IdSalidaDetalle);
              let IdSubConstruccion = ConstruccionSeleccionda[0]?.IdSubConstruccion;

              let data = {
                IdSalidas: IdSalidaDetalles.toString(','),
                IdConstruccion: ConstruccionSeleccionda[0]?.IdConstruccion,
                IdSubConstruccion: IdSubConstruccion,
                IdUserEdit: userAuth?.IdUser,
              };

              const resp = await agregarConstruccionSalidas(data);
              toastShow(toast, 'success', 'Agregada', 'Construcción agregada');
              getInfo();
              api.stopEditing();
            },
            reject: () => {},
          });

        }}
        showClear
      />
    );
  };

  const TemplateCuenta = ({ data, oldValue, api }, column) => {
    return (
      <Dropdown
        value={data?.IdAccount}
        options={cuentas}
        optionValue="IdAccount"
        optionLabel="NombreCuenta"
        filter
        filterBy="NombreCuenta"
        style={{ width: "100%" }}
        onChange={(e) => {
          let cuentaSeleccionada = cuentas.filter(i => i?.IdAccount === e?.value);
          let changes = [];
          let mensaje = "";

          if (selected.length > 0) {
            const revisados = selected.filter(item => item?.IdEstadoFinanzas === 112);
            if (revisados.length > 0 && !cuentaSeleccionada[0]) {
              toastShow(toast, 'error', 'Error', 'Una o más salidas ya están revisadas, no puede eliminar la construcción.');
              return;
            }

            changes = selected.map((item) => {
              return {
                IdSalidaDetalle: item.IdSalidaDetalle,
                IdAccount: cuentaSeleccionada[0]?.IdAccount,
                NombreCuenta: cuentaSeleccionada[0]?.NombreCuenta,
                IdEstadoFinanzas: item?.IdEstadoFinanzas,
              };
            });
          } else {
            if (data?.IdEstadoFinanzas === 112) {
              toastShow(toast, 'error', 'Error', 'La salida ya está revisada, no puede eliminar la construcción.');
              return; 
            }

            changes.push({
              IdSalidaDetalle: data.IdSalidaDetalle,
              IdAccount: cuentaSeleccionada[0]?.IdAccount,
              NombreCuenta: cuentaSeleccionada[0]?.NombreCuenta,
              IdEstadoFinanzas: data?.IdEstadoFinanzas,
            });
          }
          if (!cuentaSeleccionada[0]) {
            mensaje = `¿Está seguro de eliminar la cuenta a ${changes.length} salidas?`;
          } else {
            mensaje = <>¿Agregar cuenta <strong>{cuentaSeleccionada[0]?.NombreCuenta}</strong> a {changes.length} salidas?</>;
          }

          confirmDialog({
            message: mensaje,
            header: "Confirmación",
            icon: "pi pi-exclamation-triangle",
            accept: async () => {
              let IdSalidaDetalles = changes.map((item) => item.IdSalidaDetalle);

              let data = {
                IdSalidas: IdSalidaDetalles.toString(','),
                IdAccount: cuentaSeleccionada[0]?.IdAccount,
                IdUserEdit: userAuth?.IdUser,
              };

              const resp = await agregarCuentaSalidas(data);
              toastShow(toast, 'success', 'Agregada', 'Cuenta agregada correctamente');
              getInfo();
              api.stopEditing();
            },
            reject: () => {},
          });

        }}
        showClear
      />
    );
  };

  const columns = [
    {
      field: "IdSalidaDetalle",
      header: "ID",
      headerEn: "ID",
      className: "XXsmall",
      frozen: "frozen",
      hidden: userAuth.IdRol === 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialogSalida(true);
        setSelected(data);
      },
    },
    {
      field: "FechaSalida",
      header: "Fecha de Salida",
      headerEn: "Departure Date",
      className: "small",
      frozen: "frozen",
      Format: "DateTime2",
      
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "StatusName",
      frozen: true,
      className: "small",
      Format: "Estado",
      body: (rowData) => ({ ID: rowData.IdEstado, Estado: rowData.StatusName }),
    },
    {
      field: "Requisa",
      headerEn: "No. Material Requisition",
      header: "No. Requisa Material",
      className: "small",
      body: (rowData) => rowData.Requisa,
      Sumary: "count",
      frozen: "frozen",
      Format: "Modal",
      onCellDoubleClicked: ({ data }) => {
        setShowDialogSalida(true);
        setSelected(data);
      },
    },
    {
      field: "CodigoProducto",
      header: "Codigo Producto",
      headerEn: "Product Code",
      className: "Xsmall",
    },
    {
      field: "NombreProducto",
      header: "Nombre Producto",
      headerEn: "Product Name",
      className: "Xlarge",
    },
    {
      field: "NombreCompuesto",
      header: "Construcción",
      headerEn: "Construccion",
      editable: true,
      className: "XXXlarge",
      cellEditor: TemplateConstruccion,
    },
    {
      field: "NombreCuenta",
      header: "Cuenta",
      headerEn: "Account",
      className: "XXXlarge",
      editable: habilitar,
      cellEditor: TemplateCuenta,
    },
    {
      field: "Comentario",
      header: "Comentario",
      headerEn: "Comment",
      className: "Xlarge",
    },
    {
      field: "UnitName",
      header: "Unidad",
      headerEn: "Unit",
      className: "Xsmall",
    },
    {
      field: "NombreCategoria",
      header: "Tipo Producto",
      headerEn: "Product Type",
      className: "small",
    },
    {
      // Comment
      field: "NombreSubcategoria",
      header: "Categoría",
      headerEn: "Category",
      className: "small",
    },
    {
      field: "Area",
      header: "Area",
      headerEn: "Area",
      className: "medium",
    },
    {
      field: "NumeroIngreso",
      headerEn: "Entry Number",
      header: "No. Ingreso",
      className: "small",
      body: (rowData) => rowData.NumeroIngreso,
      Format: "Modal",
      align: "center",
      onCellDoubleClicked: ({ data }) => {
        Ingreso(data.NumeroIngreso);
      },
    },
    {
      field: "ComentarioRequisa",
      header: "Comentario Requisa",
      headerEn: "Comment Requisition",
      className: "medium",
    },
    {
      field: "UserNameDespacho",
      header: "Usuario Despacho",
      headerEn: "Usuario Despacho",
      className: "small",
    },
    {
      header: "Usuario Autorizó",
      headerEn: "User Auth",
      field: "UserNameAutorizoSolicita",
      className: "small",
    },
    {
      header: "Persona Recibio",
      headerEn: "Person Received",
      field: "NombreRecibe",
      className: "small",
    },
    {
      field: "PrecioPromedioL",
      header: "Precio L",
      Sumary: "sum",
      headerEn: "Price L",
      className: "Xsmall",
      Format: "Currency",
      hidden: hiddenCostosSalidas,
    },
    {
      field: "PrecioPromedioD",
      header: "Precio D",
      Sumary: "sum",
      headerEn: "Price D",
      className: "Xsmall",    
      Format: "Currency",
      hidden: hiddenCostosSalidas,
    },
    {
      field: "MontoL",
      header: "Monto L",
      Sumary: "sum",
      headerEn: "Monto L",
      className: "Xsmall",
      Format: "Currency",
      hidden: hiddenCostosSalidas,
    },
    {
      field: "MontoD",
      header: "Monto D",
      headerEn: "Monto D",
      Sumary: "sum",
      className: "Xsmall", 
      Format: "Currency",
      hidden: hiddenCostosSalidas,
    },
    {
      header: "Estado Finanzas",
      field: "StatusNameFinanzas",
      frozen: true,
      className: "small",
      alignFrozen: "right",
      Format: "Estado",
      body: (rowData) => ({ ID: rowData.IdEstadoFinanzas, Estado: rowData.StatusNameFinanzas }),
    },
    {
      header: "Inventario",
      headerEn: "Amount",
      field: "Inventario",
      Sumary: "sum",
      className: "Xsmall",
      Format: "Currency",
      frozen: true,
      alignFrozen: "right"
    },



    {
      header: "Solicitado",
      headerEn: "Amount",
      field: "Qty",      
      Sumary: "sum",
      className: "Xsmall",
      Format: "Currency",
      frozen: true,
      alignFrozen: "right"
    },
    {
      header: "Despachado",
      headerEn: "Amount",
      field: "QtySalida",
      Sumary: "sum",
      className: "Xsmall",
      Format: "Currency",
      frozen: true,
      alignFrozen: "right"
    },    
    {
      header: "Balance",
      Sumary: "sum",
      headerEn: "Balance",
      field: "BalanceSalida",
      className: "Xsmall",
      Format: "Currency",
      frozen: true,
      alignFrozen: "right"
    },

  ];

  const table = {
    Columns: columns,
    Data: listadoDet,
    loading: loading,
    selected: selected,
    setSelected: (e) => setSelected(e),
    showModal: (e) => showModal(e),
  };

  const showModal = (tipoModal) => {
    if (tipoModal === 'ingreso') {
      setShowDialogI(true); 
    } 
    // else if (tipoModal === 'requisaMaterial') {
    //   setShowDialogRM(true); 
    // }
  };

  const Ingreso = (Id) => {
    setIngresoToShow(Id);
    setShowDialogI(true);
    // showModal('ingreso'); 
  };

  const Salida = (Id) => {
    setShowDialogSalida(Id);
    setShowDialogI(true);
    // showModal('ingreso'); 
  };
  
  const cerrarConfirmacionI = () => {
    // Mostrar confirmación si hay ediciones sin guardar
    if (habilitar && ingresoToShow !== null) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setShowDialogI(null);
          setIngresoToShow(null); // Cerrar el diálogo
        },
        rejectLabel: "No",
        reject: () => {}, // No hacer nada si el usuario cancela
        style: { backgroundColor: "white" },
      });
    } else {
      setShowDialogI(null);
      setIngresoToShow(null);
      setHabilitar(true);
    }
  };

  const cerrarConfirmacionS = () => {
    // Mostrar confirmación si hay ediciones sin guardar
    if (habilitar && ingresoToShow !== null) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setShowDialogSalida(false);
          setIngresoToShow(null); // Cerrar el diálogo
        },
        rejectLabel: "No",
        reject: () => {}, // No hacer nada si el usuario cancela
        style: { backgroundColor: "white" },
      });
    } else {
      setShowDialogSalida(false);
      setIngresoToShow(null);
      setHabilitar(true);
    }
  };
  
  const ConfirmEliminar = () => {
    if(selected.length === 0){
      toastShow( toast, "warn", "Advertencia", "Seleccione una salida de Material a Eliminar.");
    }else{
      confirmDialog({
        message: "¿Esta seguro de eliminar la salida?",
        header: "Eliminar Salida",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Si",
        accept: () => eliminarSalida(),
        rejectLabel: "No",
        style: { backgroundColor: "white" },
      });
    }
  };

  useEffect(() => {
    // getInfo();
    setTitlePage(getLabel(baseLang, 'Salidas', config.language));
  }, []);

  return (
    <div>
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones flex-wrap">
            <h2>{getLabel(baseLang,'Salidas', config.language)}</h2>            
            <CalendarioOperativo
              dates={dates}
              setDates={setDates}
              loading={loading}
              getInfo={getInfo}
            />

            <Button
              icon="pi pi-refresh"
              tooltip="Buscar"
              onClick={() => getInfo()}
            />

            {/* <Button
              icon="pi pi-times"
              className="p-button-danger"
              tooltip="Nueva"
              onClick={() => ConfirmEliminar()}
            /> */}
          </div>
        }
        contenido={
          <div className="p-4 mt-2" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />

      {showDialogSalida && (
        <SalidasCRUD
          showDialog={showDialogSalida}
          setShowDialog={setShowDialogSalida}
          selected={selected}
          setSelected={setSelected}
          habilitar={habilitar}
          setHabilitar={setHabilitar}
        />
      )}

      <Dialog
        visible={showDialogI}
        onHide={() => {
          cerrarConfirmacionI();
        }}
        maximized={true}
        maximizable={true}
        closeOnEscape={false}
      >
        <IngresosBodegaCrud
          idIngreso={ingresoToShow}
          setIngresoToShow={setIngresoToShow}
          showDialog={showDialogI}
          habilitar={habilitar}
          setHabilitar={setHabilitar}
          editable={false}
        />
      </Dialog>
    </div>
  );
};

export default SalidasScreen;